import store from '../store/index'
const baseSize = 12.5
// 设置 rem 函数
function setRem() {
  // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
  const scale = document.documentElement.clientWidth / 1920
  // console.log('scale', scale)
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) > 8 ? (baseSize * Math.min(scale, 2)) + 'px' : '8px'
}

function checkFull() {
  var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
  // to fix : false || undefined == undefined
  if (isFull === undefined) {
    isFull = false
  }
  return isFull
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem()
  if (!checkFull()) {
    store.commit('global/SET_VALUE', { name: 'isFullscreen', value: false })
  }
}
